import React from 'react';
import { Box, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import VoucherDetail from './VoucherDetail';
import { VoucherCode, Trial } from '../../redux/types';

export type VoucherSuccessProps = {
  voucherDetail: VoucherCode & { trial: Trial };
  email?: string;
  onNewLoginClick: () => void;
  onRegisterClick: () => void;
  onContinueLoginClick: () => void;
}

const VoucherSuccess: React.FC<VoucherSuccessProps> = ({
  voucherDetail, onNewLoginClick, onRegisterClick, onContinueLoginClick, email,
}: VoucherSuccessProps) => {
  const isEmail = !!email;
  return (
    <VoucherDetail voucherDetail={voucherDetail}>
      <p>
        <FormattedMessage id="voucher.proceedLogin" />
      </p>
      {
        isEmail
        && (
          <>
            <Box>
              <Button
                style={{ maxWidth: '250px' }}
                variant="contained"
                color="primary"
                onClick={onContinueLoginClick}
              >
                {`continue as ${email}`}
              </Button>
            </Box>
            <p>or</p>
          </>
        )
      }
      <Box display="flex" gap={1} justifyContent="center">
        <Button
          sx={{ maxWidth: '250px' }}
          variant="contained"
          color="primary"
          onClick={onNewLoginClick}
        >
          {
            isEmail ? <FormattedMessage id="voucher.loginDiffernt" /> : <FormattedMessage id="voucher.login" />
          }
        </Button>
        <Button
          sx={{ maxWidth: '250px' }}
          variant="outlined"
          onClick={onRegisterClick}
        >
          <FormattedMessage id="voucher.signup" />
        </Button>
      </Box>
    </VoucherDetail>
  );
};

export default VoucherSuccess;
